<template>




  <div v-for="(addon, index) in priceAddons" :key="index"> 
    <label v-if="shouldDisplayCategory(addon.category)" @click="handleAddonSelection(addon)" class="w-full cursor-pointer">
    <fieldset class="border border-gray-300"
    :class="[ addon.isChecked ? 'ring-2 ring-secondary-500': 'border-gray-300']" >
      <div class="w-full flex gap-3 justify-between h-12"> 
      <div class="flex gap-3">
        <div class="flex h-6 shrink-0 items-center">
          <div class="group grid size-4 grid-cols-1">
            <input :id="'addon-' + index" aria-describedby="addon-description" name="addon" type="checkbox"
                   v-model="addon.isChecked"
                   @change="handleAddonSelection(addon)"
                   class="px-2 py-2 col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-primary-500 checked:bg-primary-500 indeterminate:border-primary-500 indeterminate:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto" />
            <svg class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
                 viewBox="0 0 14 14" fill="none">
              <path class="opacity-0 group-has-[:checked]:opacity-100" d="M3 8L6 11L11 3.5" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
              <path class="opacity-0 group-has-[:indeterminate]:opacity-100" d="M3 7H11" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
        </div>
        <div class="text-sm/6">
          <label :for="'addon-' + index" class="font-medium text-gray-900">{{ addon.name }}</label>
          <div class="text-neutral-500 text-sm">
            {{ $n(addon.price ?? 0, 'currency') }} {{ addon.unit }}
          </div>
        </div>
      </div>
      <div v-if="addon.isChecked">
        <fieldset class="border border-neutral-500 flex items-center p-2 mb-0">
          <button @click.stop="decrement(addon)" :disabled="addon.category === 'all'" class="px-2 py-1 bg-transparent rounded disabled:bg-transparent disabled:text-gray-300">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z"
                    clip-rule="evenodd" />
            </svg>
          </button>
          <span class="mx-2 w-4 text-center">{{ addon.quantity }}</span>
          <button @click.stop="increment(addon)"  :disabled="addon.category === 'all'" class="px-2 py-1 bg-transparent rounded disabled:bg-transparent disabled:text-gray-300">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd" />
            </svg>
          </button>
        </fieldset>
      </div>
      </div>
      <div class="text-sm/6 text-gray-500 pt-1 ml-7">
       {{ addon.description }}
      </div>

    </fieldset>
    </label>
  </div>

</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  created() {
          this.priceAddons = this.order.reservation?.price_addon.map(
            addon => {
              const prev = this.order.addons?.find(a => a.name === addon.name); 
              return {
            ...addon,
            isChecked: (prev?.quantity ?? 0) > 0,
            amount: prev?.amount ?? 0,
            quantity: prev?.quantity ?? 0
            }; });
    },
  data() {
    return {    
      priceAddons: []
    };
  },
  emits: ['update'],
  computed: {
    selected() {
        return this.priceAddons?.filter((addon) => addon.isChecked && addon.quantity > 0) || [];
    }
  },
  methods: {
    handleAddonSelection(addon) {
      if (addon.isChecked) {
        if (addon.category === 'all') {
          addon.quantity = this.getParticipantsCount(addon.category);
          addon.amount = addon.price * addon.quantity;
        } else {
          addon.quantity = 1;
          addon.amount = addon.price;
        }
      } else {
        addon.quantity = 0;
        addon.amount = 0;
      }
      this.updateSelectedAddons(this.selected);
    },
    increment(addon) {
      addon.quantity++;
      addon.amount = addon.price * addon.quantity;
      this.updateSelectedAddons(this.selected);
    },
    decrement(addon) {
      if (addon.quantity > 0) { 
        addon.quantity--;
        addon.amount = addon.price * addon.quantity;
        this.updateSelectedAddons(this.selected);
      }
    },

    updateSelectedAddons(selected) {
      // this.$emit("update",selected);
      this.order.setAddOns(selected);
    },
    getParticipantsCount(category) {
      return this.order.getCount(category);
    },

    shouldDisplayCategory(category) {
      if (category === 'all') return true;
      if (category === 'selected') return true;
      return this.order.count[category]  > 0;
    },
  },
};
</script>